export { default as Banner } from './Banner';
export { default as ExclusiveRewards } from './ExclusiveRewards';
export { default as Faq } from './Faq';
export { default as HowItWorks } from './HowItWorks';
export { default as JoinAndEarnRewards } from './JoinAndEarnRewards';
export { default as YourPoints } from './YourPoints';
